import { useMemo } from "react";
import _ from "lodash";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { twMerge } from "tailwind-merge";

import { useMenu } from "../../../store/global/useMenu";
import { LinkSubmenu } from "./link-submenu";
import { LinkSubmenuIcon } from "./link-submenu-icon";
import { useLinkContext } from "./link-context";


export function LinkItem({ to, hidden, className, children, ...rest }) {
  const ctx = useLinkContext()

  const linkActions = useMenu.getState().actions
  const hasSubmenu = _.isArray(to) && to.length > 0;

  const item = useMenu(st => st.data.itens[ctx.name])
  const menuOpen = useMenu(st => st.data.open)


  const ItemComponent = hasSubmenu ? "div" : Link;

  return (
    <motion.div
      key={ctx.name}
      initial={{ x: "-100%", opacity: 0 }}
      animate={{ x: "0%", opacity: 1 }}
      exit={{ x: "-100%", opacity: 0 }}
      transition={{ duration: 0.3, ease: "easeInOut" }}
      data-open={item?.open}
      data-active={item?.active}
      data-menu-open={menuOpen}
      className="group relative flex flex-wrap flex-col w-full items-start justify-start"
    >
      <ItemComponent
        {...rest}
        to={hasSubmenu ? undefined : to}
        onClick={() => linkActions.toggleItem(ctx.name)}
        className={twMerge(
          "flex bg-white flex-nowrap gap-2 cursor-pointer relative items-center justify-start w-full py-3 px-6 text-zinc-500 transition duration-700 group-data-[open=true]:bg-white group-data-[open=true]:font-bold group-data-[active=true]:text-scale-500 group-data-[active=true]:font-semibold group-data-[open=true]:pl-6 group-hover:!bg-scale-500 group-hover:!text-white group-hover:!font-bold group-hover:!pl-7 group-hover:!duration-200",
          "group-hover:!pl-6",
          hasSubmenu && "group-data-[open=true]:group-data-[menu-open=false]:w-48 group-data-[open=true]:group-data-[menu-open=false]:rounded-tr-md ",
          className)}
      >
        {children}
        {hasSubmenu && <LinkSubmenuIcon />}
      </ItemComponent>
      {hasSubmenu && <LinkSubmenu list={to} />}
    </motion.div>
  );
}
